module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-3.7f7690ac.webp";